import type { ElementType, ReactNode } from "react";
import { text, type TextTone, type TextVariant } from "@web/theme/theme";

export type TextProps = {
  variant?: TextVariant;
  tone?: TextTone;
  /** Tabular figures (money, counts). */
  tabular?: boolean;
  align?: "left" | "center" | "right";
  as?: ElementType;
  className?: string;
  children: ReactNode;
};

const defaultTag: Record<TextVariant, ElementType> = {
  "large-title": "h1",
  title: "h2",
  headline: "h3",
  body: "p",
  callout: "p",
  caption: "span",
};

const alignClasses = { left: "text-left", center: "text-center", right: "text-right" } as const;

export function Text({ variant = "body", tone = "default", tabular, align, as, className = "", children }: TextProps) {
  const Tag = as ?? defaultTag[variant];
  const alignClass = align ? alignClasses[align] : "";
  return <Tag className={`${text.variant[variant]} ${text.tone[tone]} ${tabular ? text.tabular : ""} ${alignClass} ${className}`.trim()}>{children}</Tag>;
}
